export const METLIFE_FIELDS = [
  'UserId',
  'EmployeeId',
  'Email',
  'TypeOfApplication',
  'MetLifeIdNumber',
  'Name',
  'PolicyApplicantName',
  'Designation',
  'DateOfBirth',
  'MobileNumber',
  'BankInfoJson',
  'BusinessUnitName',
  'RequestDepartmentId',
  'RequestDepartmentName',
  'Gender',
  'WantsMaternityBenefit',
  'Status',
  'AppliedDateUtc',
  'ApprovedBy',
  'ApprovedByName',
  'ApprovedDateUtc',
  'ApprovalStatusReason',
  'DepartmentId',
  'Timezone',
] as const;
